<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="time"
        :label="label"
        prepend-icon="mdi-clock-time-four-outline"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="timepicker"
      v-model="time"
      full-width
      :allowed-hours="allowedHours"
      :min="min"
      format="24hr"
      @click:minute="saveTime(time)"
    >
  </v-time-picker>
  </v-menu>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    min: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      time: null,
      timepicker: true,
      menu: false,
      allowedHours: [
        7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
      ],
    };
  },
  methods: {
    saveTime(time) {
      this.$refs.menu.save(time);
      this.$emit("update", time);
    },
  },
};
</script>
